import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UtilService } from '../../app/util/UtilService';
import { ResizeController } from '../ResizeController';

@Directive({
    selector: '[resizeText]',
    standalone: false
})
export class ResizeTextDirective extends ResizeController {
  @Input('resizeText') fontSize: number;
  @Output() resizeEmitter = new EventEmitter<any>();
  constructor(
    private el: ElementRef,
    public _utilService: UtilService
  ) {
    super(_utilService);
  }
  ngOnInit() {
    this.initialize();
  }

  ngOnChanges(data) {
    if (data.fontSize) {
      if (!data.fontSize.firstChange) {
        this.initialize();
      }
    }
  }

  initialize() {
    this.el.nativeElement.style.fontSize = this.fontSize + 'px';
    this.resizeHandler();
  }

  resize(
    newGameScale,
    offsetLeft,
    offsetTop,
    windowWidth,
    windowHeight,
    isBlockPortrait
  ) {
    this.el.nativeElement.style.fontSize = this.fontSize * newGameScale + 'px';
    this.resizeEmitter.emit(newGameScale);
  }
}
